import { render, staticRenderFns } from "./InvoiceTable.vue?vue&type=template&id=e427fe2a&scoped=true&"
import script from "./InvoiceTable.vue?vue&type=script&lang=ts&"
export * from "./InvoiceTable.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceTable.vue?vue&type=style&index=0&id=e427fe2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e427fe2a",
  null
  
)

export default component.exports